"use strict";
/* globals module */
/**
 * @module articleInstanceFilesStreamsRoute
 * @description Baasic Article Instance Files Streams Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Files Streams Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
var contracts_1 = require("../../../core/contracts");
var ArticleInstanceFilesStreamsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleInstanceFilesStreamsRoute, _super);
    function ArticleInstanceFilesStreamsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'articles/{articleId}/file-streams/{id}/{?width,height,t}';
        _this.createRoute = 'articles/{articleId}/file-streams/{filename}';
        _this.updateRoute = 'articles/{articleId}/file-streams/{id}';
        return _this;
    }
    /**
     * Parses get route; this route should be expanded with id of desired file stream. Additional supported items are:
     * - `width` - width of desired derived image.
     * - `height` - height of desired derived image.
     * - `t` - cache invalidation param.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article file need to be retrieved.
     * @param data Article File object used to identify stream that needs to be retrieved from the system.
     * @example articleInstanceFilesRoute.get({id: '<filename>'});
     **/
    ArticleInstanceFilesStreamsRoute.prototype.get = function (articleId, data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        var params = this.utility.extend({}, data);
        params.articleId = articleId;
        return _super.prototype.baseCreate.call(this, this.getRoute, params);
    };
    /**
     * Parses create route; this route should be expanded with the filename which indicates where the stream will be saved.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article file need to be inserted.
     * @param data Article File object that need to be inserted into the system.
     * @example articleInstanceFilesRoute.create({filename: '<filename>'});
     **/
    ArticleInstanceFilesStreamsRoute.prototype.create = function (articleId, data) {
        var params = this.utility.extend({}, data);
        params.articleId = articleId;
        return _super.prototype.baseCreate.call(this, this.createRoute, params);
    };
    /**
     * Parses update route; this route should be expanded with the id of the previously saved resource. Additional supported items are:
     * - `width` - width of derived image to update.
     * - `height` - height of derived image to update.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article file need to be updated.
     * @param data Article File object used to identify stream that needs to be updated.
     * @example articleFilesRoute.update({id: '<filename>'});
     **/
    ArticleInstanceFilesStreamsRoute.prototype.update = function (articleId, data) {
        var params = this.utility.extend({}, data);
        params.articleId = articleId;
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    ArticleInstanceFilesStreamsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleInstanceFilesStreamsRoute);
    return ArticleInstanceFilesStreamsRoute;
}(common_1.BaseRoute));
exports.ArticleInstanceFilesStreamsRoute = ArticleInstanceFilesStreamsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 
